angular.module('resources.routes', [
  'ui.router'
]).config(function config($stateProvider) {
  $stateProvider.state('resources', {
    url: '/faqs/:section',
    params: {
      section: { value: null, squash: true }
    },
    controller: "ResourcesCtrl",
    templateUrl: 'components/resources/resources.html'
  });
})
